module.exports = __webpack_public_path__ + "img/roxburghm.092f014c.jpg";